import request from '@/utils/request'

// 常量
const api_name_23Year = '/year/AnnualStudyChecklist2023'
const api_name_24January = 'year/JanStudyChecklist2024'
const api_name_24February = 'year/FebStudyChecklist2024'
const api_name_24March = 'year/Q1StudyChecklist2024'
const api_name_24April = 'year/aprStudyChecklist2024'
const api_name_24May = 'year/mayStudyChecklist2024'
const api_name_24June = 'year/SemiStudyChecklist2024'
const api_name_24July = 'year/JulStudyCheckList2024'
const api_name_24August = 'year/augStudyChecklist2024'
const api_name_24September = 'year/Q3StudyChecklist2024'
const api_name_24October = 'year/OctStudyChecklist2024'
const api_name_24November = 'year/novStudyChecklist2024'
const api_name_24Year = '/year/AnnualStudyChecklist2024'

export default {
  // 列表
  getDataFor23Year(jobNo) {
    return request({
      // 接口路径
      url: `${api_name_23Year}/getOneByJobNo/${jobNo}`,
      method: 'get', // 提交方式
    })
  },
  getDataFor24January(jobNo) {
    return request({
      // 接口路径
      url: `${api_name_24January}/getOneByJobNo/${jobNo}`,
      method: 'get', // 提交方式
    })
  },
  getDataFor24February(jobNo) {
    return request({
      // 接口路径
      url: `${api_name_24February}/getOneByJobNo/${jobNo}`,
      method: 'get', // 提交方式
    })
  },
  getDataFor24March(jobNo) {
    return request({
      // 接口路径
      url: `${api_name_24March}/getOneByJobNo/${jobNo}`,
      method: 'get', // 提交方式
    })
  },
  getDataFor24April(jobNo) {
    return request({
      // 接口路径
      url: `${api_name_24April}/getOneByJobNo/${jobNo}`,
      method: 'get', // 提交方式
    })
  },
  getDataFor24May(jobNo) {
    return request({
      // 接口路径
      url: `${api_name_24May}/getOneByJobNo/${jobNo}`,
      method: 'get', // 提交方式
    })
  },
  getDataFor24June(jobNo) {
    return request({
      // 接口路径
      url: `${api_name_24June}/getOneByJobNo/${jobNo}`,
      method: 'get', // 提交方式
    })
  },
  getDataFor24July(jobNo) {
    return request({
      // 接口路径
      url: `${api_name_24July}/getOneByJobNo/${jobNo}`,
      method: 'get', // 提交方式
    })
  },
  getDataFor24August(jobNo) {
    return request({
      // 接口路径
      url: `${api_name_24August}/getOneByJobNo/${jobNo}`,
      method: 'get', // 提交方式
    })
  },
  getDataFor24September(jobNo) {
    return request({
      // 接口路径
      url: `${api_name_24September}/getOneByJobNo/${jobNo}`,
      method: 'get', // 提交方式
    })
  },
  getDataFor24October(jobNo) {
    return request({
      // 接口路径
      url: `${api_name_24October}/getOneByJobNo/${jobNo}`,
      method: 'get', // 提交方式
    })
  },
  getDataFor24November(jobNo) {
    return request({
      // 接口路径
      url: `${api_name_24November}/getOneByJobNo/${jobNo}`,
      method: 'get', // 提交方式
    })
  },
  getDataFor24Year(jobNo) {
    return request({
      // 接口路径
      url: `${api_name_24Year}/getOneByJobNo/${jobNo}`,
      method: 'get', // 提交方式
    })
  },
  getDataFor25January(jobNo) {
    return request({
      // 接口路径
      url: `/year/JanStudyChecklist2025/getOneByJobNo/${jobNo}`,
      method: 'get', // 提交方式
    })
  },
  getDataFor25February(jobNo) {
    return request({
      // 接口路径
      url: `/year/FebStudyChecklist2025/getOneByJobNo/${jobNo}`,
      method: 'get', // 提交方式
    })
  },
  getDataFor25March(jobNo) {
    return request({
      // 接口路径
      url: `/year/Q1StudyChecklist2025/getOneByJobNo/${jobNo}`,
      method: 'get', // 提交方式
    })
  },
  getDataFor25April(jobNo) {
    return request({
      // 接口路径
      url: `/year/aprStudyChecklist2025/getOneByJobNo/${jobNo}`,
      method: 'get', // 提交方式
    })
  },
  getDataFor25May(jobNo) {
    return request({
      // 接口路径
      url: `/year/mayStudyChecklist2025/getOneByJobNo/${jobNo}`,
      method: 'get', // 提交方式
    })
  },
  getDataFor25June(jobNo) {
    return request({
      // 接口路径
      url: `/year/SemiStudyChecklist2025/getOneByJobNo/${jobNo}`,
      method: 'get', // 提交方式
    })
  },
  getDataFor25July(jobNo) {
    return request({
      // 接口路径
      url: `/year/julStudyChecklist2025Copy1/getOneByJobNo/${jobNo}`,
      method: 'get', // 提交方式
    })
  },
  getDataFor25Aug(jobNo) {
    return request({
      // 接口路径
      url: `/year/augStudyChecklist2025/getOneByJobNo/${jobNo}`,
      method: 'get', // 提交方式
    })
  },
  getDataFor25Sep(jobNo) {
    return request({
      // 接口路径
      url: `/year/Q3StudyChecklist2025/getOneByJobNo/${jobNo}`,
      method: 'get', // 提交方式
    })
  },
  getDataFor25Oct(jobNo) {
    return request({
      // 接口路径
      url: `/year/OctStudyChecklist2025/getOneByJobNo/${jobNo}`,
      method: 'get', // 提交方式
    })
  },
  getDataFor25Nov(jobNo) {
    return request({
      // 接口路径
      url: `/year/novStudyChecklist2025/getOneByJobNo/${jobNo}`,
      method: 'get', // 提交方式
    })
  },
}